import { Component } from "solid-js";

interface NewBrandsIconProps {
  class?: string;
}

export const NewBrandsIcon: Component<NewBrandsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0001 21.3356C16.0001 18.3889 18.3889 16 21.3357 16C18.3889 16 16.0001 13.6112 16.0001 10.6645C16.0001 13.6112 13.6113 16 10.6646 16C13.6113 16 16.0001 18.3889 16.0001 21.3356Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.0051 15.9999C28.0051 22.6301 22.6303 28.0049 16.0001 28.0049C9.36994 28.0049 3.99512 22.6301 3.99512 15.9999C3.99512 9.36976 9.36994 3.99493 16.0001 3.99493"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.3374 10.6645C25.3374 8.45441 27.129 6.6628 29.339 6.6628C27.129 6.6628 25.3374 4.87119 25.3374 2.66113C25.3374 4.87119 23.5458 6.6628 21.3357 6.6628C23.5458 6.6628 25.3374 8.45441 25.3374 10.6645Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
